// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1AJze","title":"AfterFrontImage_title__3pxem"};